import React from 'react';
import styled from 'styled-components';
import { DashboardLayout, InnerPageHeader } from 'src/skins/pluto/components/layouts';
import { TermsContent } from 'src/skins/common/components';

const Wrapper = styled.div`
  margin-bottom: 3.5rem;
  color: ${props => props.theme.color.pluto.text || props.theme.color.text};
`;

export const Terms = () => {
  return (
    <DashboardLayout>
      <Wrapper>
        <InnerPageHeader navigateBackTo="/dashboard/settings">
          <h4>Terms of use</h4>
        </InnerPageHeader>

        <TermsContent />
      </Wrapper>
    </DashboardLayout>
  );
};

export default Terms;
